import { MuscleToVector } from "@project-rouge/rg-three";
import { Vector3 } from "three";
const muscleV = new Vector3();
const muscleDir = new Vector3();
function getRealMusclePoint(muscle, pointIndex, out = new Vector3()) {
  if (muscle.lockEnds[pointIndex])
    return out.fromArray(muscle.points[pointIndex]);
  MuscleToVector(muscle, muscleV);
  const dir = muscleDir.copy(muscleV).normalize();
  const length = muscleV.length();
  const diff = (length - muscle.realLength) * (pointIndex ? -1 : 1);
  return out.fromArray(muscle.points[pointIndex]).addScaledVector(dir, diff);
}
export {
  getRealMusclePoint
};
//# sourceMappingURL=index167.js.map
